import {AbortTest} from './abortTest';
import {Help} from './help';
import {NextSection} from './nextSection';

export const modals = {
    "Help": Help,
    "AbortTest": AbortTest,
    "NextSection": NextSection 
};